module.exports = __webpack_public_path__ + "img/successfull.e6b59c03.png";